import React from "react";

function Loading() {
  return (
    <div className="loading-container">
      <div class="loadingio-spinner-rolling-r3dp7lp55jq">
        <div class="ldio-l53b49yt6y">
          <div></div>
        </div>
      </div>
    </div>
  );
}

export default Loading;
